import { Menu, Shield, User, ChevronDown } from "lucide-react";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { LogoutManually, LogoutUser, useAppDispatch } from "../../../redux";
const HeaderComponent = ({ setIsMobileMenuOpen }) => {
    const { isAuthenticated, rehydrated, user } = useSelector((state: any) => state.auth);
    const [showUserMenu, setShowUserMenu] = useState(false);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await dispatch(LogoutUser({})).unwrap();
            // Navigation is handled in the LogoutUser action
        } catch (error: any) {
            if (error === 401) {
                dispatch(LogoutManually());
                // Navigate after manual logout
                requestAnimationFrame(() => {
                    window.location.replace("/");
                });
            }
        }
    };
    return (
        <header className="bg-white border-b fixed top-0 inset-x-0 z-40 h-16" style={{ textAlign: "left" }}>
            <div className="flex items-center justify-between h-full px-4">
                <div className="flex items-center gap-4">
                    <button
                        onClick={() => setIsMobileMenuOpen()}
                        className="lg:hidden p-2"
                    >
                        <Menu className="h-6 w-6" />
                    </button>
                    <Link to="/admin/dashboard" className="flex items-center gap-2">
                        <Shield className="h-8 w-8 text-blue-600" />
                        <span className="text-xl font-bold text-blue-600">Kokobeo</span>
                    </Link>
                </div>

                <div className="flex items-center gap-4">
                    <div className="relative">
                        <button
                            onClick={() => setShowUserMenu(!showUserMenu)}
                            className="flex items-center gap-2"
                        >
                            <div className="h-8 w-8 bg-gray-100 rounded-full flex items-center justify-center">
                                <User className="h-5 w-5" />
                            </div>
                            <span className="font-medium">Admin</span>
                            <ChevronDown className="h-4 w-4" />
                        </button>

                        {showUserMenu && (
                            <div className="absolute right-0 mt-2 w-48 bg-white rounded shadow-lg border">
                                <div className="p-4 border-b">
                                    <p className="font-medium">{`${user.firstName || ""} ${user.lastName || ""
                                        }`}</p>
                                    <p className="text-sm text-gray-500">{user.email}</p>
                                </div>
                                <Link to="/admin/settings" className="block px-4 py-2 hover:bg-gray-50">Settings</Link>
                                <Link to="/admin/security" className="block px-4 py-2 hover:bg-gray-50">Security</Link>
                                <button className="w-full text-left px-4 py-2 text-red-600 hover:bg-gray-50 border-t" onClick={() => handleLogout()}>Log Out</button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default HeaderComponent;